

export const buildLookupRequest = (skip = 0, take = null, fieldName = 'name', filterValue = '', staticFilters = [], sortFieldName = null) => {
  const request = {
    skip,
    sort: [{ field: sortFieldName || fieldName, dir: 'asc' }],
    filter: {
      filters: [
        { field: `toLower(${fieldName})`, operator: 'contains', value: (filterValue || '').toLowerCase() },
        ...staticFilters
      ],
      logic: 'and'
    }
  }
  if (take) { return {...request, take: take} }
  return request
}